// extracted by mini-css-extract-plugin
module.exports = {"bylineContainer":"Byline_bylineContainer__WhCT8","explaining":"Byline_explaining__W51ge","longform":"Byline_longform__JRYJG"};